import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';

// A freak character's art; the context emoji while the art is missing or fails to load.
export default function FreaksCharacterImage({ imageUrl, emoji, size, locked = false }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [imageUrl]);

  return (
    <Box
      sx={{
        width: size, height: size, borderRadius: '50%', flexShrink: 0, overflow: 'hidden',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: locked ? '#2a2a2a' : '#1e1e1e',
      }}
    >
      {imageUrl && !failed ? (
        <Box
          component="img"
          src={imageUrl}
          alt=""
          onError={() => setFailed(true)}
          // a locked stage is a teaser: a dark silhouette
          sx={{ width: size, height: size, objectFit: 'contain', filter: locked ? 'brightness(0)' : 'none' }}
        />
      ) : (
        <Box component="span" sx={{ fontSize: size * 0.55, lineHeight: 1, opacity: locked ? 0.25 : 1 }}>{emoji}</Box>
      )}
    </Box>
  );
}
